export {default} from 'netxcore@netx/core-app/index';

import AdvancedMenuView from './views/advancedMenuView';
const Netx = (window.Netx = window.Netx || {});
Netx.Views = Netx.Views || {};
Netx.Views.AdvancedMenuView = AdvancedMenuView;

import './css/style.less';
